var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_895_17671",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_895_17671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99844 14.6664C7.1651 14.6664 6.38455 14.5081 5.65677 14.1914C4.92899 13.8747 4.29566 13.447 3.75677 12.9081C3.21788 12.3692 2.7901 11.7359 2.47344 11.0081C2.15677 10.2803 1.99844 9.49974 1.99844 8.66641C1.99844 7.83307 2.15677 7.05252 2.47344 6.32474C2.7901 5.59696 3.21788 4.96363 3.75677 4.42474C4.29566 3.88585 4.92899 3.45807 5.65677 3.14141C6.38455 2.82474 7.1651 2.66641 7.99844 2.66641C8.83177 2.66641 9.61233 2.82474 10.3401 3.14141C11.0679 3.45807 11.7012 3.88585 12.2401 4.42474C12.779 4.96363 13.2068 5.59696 13.5234 6.32474C13.8401 7.05252 13.9984 7.83307 13.9984 8.66641C13.9984 9.49974 13.8401 10.2803 13.5234 11.0081C13.2068 11.7359 12.779 12.3692 12.2401 12.9081C11.7012 13.447 11.0679 13.8747 10.3401 14.1914C9.61233 14.5081 8.83177 14.6664 7.99844 14.6664ZM9.8651 11.4664L10.7984 10.5331L8.6651 8.39974V5.33307H7.33177V8.93307L9.8651 11.4664ZM3.73177 1.56641L4.6651 2.49974L1.83177 5.33307L0.898438 4.39974L3.73177 1.56641ZM12.2651 1.56641L15.0984 4.39974L14.1651 5.33307L11.3318 2.49974L12.2651 1.56641Z",
    fill: "#FFDD00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.996102528ce6f54c171f5c1631d63dce.svg";
export { ForwardRef as ReactComponent };